import React from 'react';
import PickerBase from './PickerBase';
import { MODES } from './valueFormat';

export const TimeInput = (props) => <PickerBase {...props} mode={MODES.TIME} />;
export const DateInput = (props) => <PickerBase {...props} mode={MODES.DATE} />;
export const DateTimeInput = (props) => <PickerBase {...props} mode={MODES.DATETIME} />;
